import { Paragraph, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type Props = {
  description: string;
  planName: string;
  currency: string;
  price: string;
};

const PricingInformation = ({
  description,
  planName,
  currency,
  price,
}: Props) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        Pricing INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Plan Name :
          </Typography>
          <Typography className="value">{planName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Currency :
          </Typography>
          <Typography className="value">{currency}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Price :
          </Typography>
          <Typography className="value">{price}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title" fontColor="dark">
            Description :
          </Typography>
          <div className="value">
            <Paragraph numberOfLines={3} text={description} />
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default PricingInformation;
